import { DeskingOffer } from './legos/deskingTypes';
import { FinanceType } from './constants';

const financeTypeOrder = [
  FinanceType.PURCHASE,
  FinanceType.LEASE,
  FinanceType.CASH,
];

/**
 * This is a basic JS sort function for desking offers to sort based on the data.
 * First, the offers should be grouped by finance type:
 *   left-to-right: Purchase, Lease, Cash
 *
 * For Purchase offers, they should be sorted by months and then APR
 * For Lease offers, the should be sorted by months, mileage, and then Rate
 *
 * If all of the above fields match, then the sort should be based on created data
 */
export function sortDeskingOffers(offerA: DeskingOffer, offerB: DeskingOffer) {
  if (!offerA.data || !offerB.data) {
    // Unable to reorder offers
    return 0;
  }

  if (offerA.data?.financeType !== offerB.data?.financeType) {
    // Sort by offer finance type first
    return (
      financeTypeOrder.indexOf(offerA.data.financeType) -
      financeTypeOrder.indexOf(offerB.data.financeType)
    );
  }

  if (
    offerA.data.financeType === FinanceType.PURCHASE &&
    offerB.data.financeType === FinanceType.PURCHASE
  ) {
    if (offerA.data.months !== offerB.data.months) {
      return offerA.data.months - offerB.data.months;
    }
    if (offerA.data.apr !== offerB.data.apr) {
      return offerA.data.apr - offerB.data.apr;
    }
  }
  if (
    offerA.data.financeType === FinanceType.LEASE &&
    offerB.data.financeType === FinanceType.LEASE
  ) {
    if (offerA.data.months !== offerB.data.months) {
      return offerA.data.months - offerB.data.months;
    }
    if (offerA.data.mileage !== offerB.data.mileage) {
      return offerA.data.mileage - offerB.data.mileage;
    }
    if (offerA.data.rate !== offerB.data.rate) {
      return offerA.data.rate - offerB.data.rate;
    }
  }

  const offerACreatedAt =
    offerA.createdAt && offerA.createdAt instanceof Date
      ? offerA.createdAt.getTime()
      : new Date((offerA.createdAt as unknown) as string).getTime();
  const offerBCreatedAt =
    offerA.createdAt && offerA.createdAt instanceof Date
      ? offerA.createdAt.getTime()
      : new Date((offerA.createdAt as unknown) as string).getTime();

  return offerACreatedAt - offerBCreatedAt;
}
